import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BwaBranchDataReferral } from '../../Models/Domains/BankAccount/BwaBranchDataReferral';
import { BwaBankAccountValidationRequest } from '../../Models/Domains/BankAccount/BwaBankAccountValidationRequest';
import { ExperianMessageType } from '../../Models/Domains/BankAccount/ExperianMessageType';

declare var IS_RUNNING_IN_APP_POOL;

export class ExperianBankAccountValidationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(request: BwaBankAccountValidationRequest): Promise<BwaBranchDataReferral, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BankAccount/ExperianBankAccountValidation/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.post<BwaBranchDataReferral, any>(url, data);
  }
  public get(instructionId: number, wizardSessionId: number, messageType: ExperianMessageType): Promise<Array<BwaBranchDataReferral>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BankAccount/ExperianBankAccountValidation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId, wizardSessionId: wizardSessionId, messageType: messageType }

    return AjaxWrapper.get<Array<BwaBranchDataReferral>, any>(url, data);
  }
}

